import { render } from "./OrderDetails.vue?vue&type=template&id=3f8a5da4&scoped=true&ts=true"
import script from "./OrderDetails.vue?vue&type=script&lang=ts"
export * from "./OrderDetails.vue?vue&type=script&lang=ts"

import "./OrderDetails.vue?vue&type=style&index=0&id=3f8a5da4&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8a5da4"]])

export default __exports__